var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"text-xs py-1 px-2 text-center flex items-center whitespace-nowrap font-bold bg-blue-600 text-white rounded-full capitalize"},[_vm._v(" "+_vm._s(_vm.item.visibilty)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }